import React from 'react';
import { Col, Row, Container, Card, CardHeader, CardBody } from 'reactstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';

import RiskClassTimeSeries from './RiskClassTimeSeries';



const VskorAdmin = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Vskor Admin" pageTitle="Vskor" />
                <Row>
           
                    <Col lg={12}>
                        <Row className="mb-2">
                            <Col lg={12} md={12} className="mb-2">
                                <RiskClassTimeSeries />
                            </Col>

                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default VskorAdmin;
